export const pushEvent = (payload: { event?: string }) => {
  if (window.dataLayer) {
    window.dataLayer.push(payload);
  }
};
